import React, { useState, useEffect, useCallback, useRef } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import PlaylistModal from "./PlaylistModal";
import {
  Button,
  CircularProgress,
  TextField,
  Select,
  MenuItem,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  Skeleton,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  Chip,
  IconButton,
} from "@mui/material";
import Header from "../NewUi/Header/header";
import { Form, Field } from "react-final-form";
import { Autocomplete } from "mui-rff";
import styles from "./VideoManager.module.scss";
import debounce from "lodash.debounce";
import ReactPlayerMain from "react-player";
import { toast } from "react-toastify";
import { Delete, Clear as ClearIcon } from "@mui/icons-material";
import { confirmAlert } from "react-confirm-alert";
import { useNavigate } from "react-router-dom";
import PublicIcon from "@mui/icons-material/Public";
import Person2Icon from "@mui/icons-material/Person2";
import ArchiveIcon from "@mui/icons-material/Archive";
import DeleteIcon from "@mui/icons-material/Delete";
import BusinessIcon from "@mui/icons-material/Business";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import Groups2Icon from "@mui/icons-material/Groups2";
import Lottie from "lottie-react";
import videoLoadingAnimation from "../animation/Animation - 1741783692232.json";

export default function VideoManager() {
  const [categories, setCategories] = useState<any[]>([]);
  const [currentCategory, setCurrentCategory] = useState<any | null>(null);
  const [currentVideo, setCurrentVideo] = useState<any | null>(null);
  const [loading, setLoading] = useState(true);
  const [searchLoading, setSearchLoading] = useState(false);
  const [searchParam, setSearchParam] = useState("");
  const [treatments, setTreatments] = useState<any[]>([]);
  const [selectedTreatment, setSelectedTreatment] = useState("");
  const [userid, setUserId] = useState("");
  const [practiceId, setPracticeId] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [openModalPlaylist, setOpenModalPlaylist] = useState(false);
  const queryClient = useQueryClient();
  const startTimeRef = useRef<number | null>(null);
  const playbackTimeRef = useRef(0);
  const [selectedCategoryId, setSelectedCategoryId] = useState<number | null>(
    null
  );
  const [selectedCategoryName, setSelectedCategoryName] = useState("");
  const [lastPlayedSeconds, setLastPlayedSeconds] = useState<number | null>(
    null
  );
  const [playedBeforePause, setPlayedBeforePause] = useState<number | null>(
    null
  );
  const [seekTime, setSeekTime] = useState<number | null>(null);
  const navigate = useNavigate();
  const [level, setLevel] = useState("");
  const [isArchived, setIsArchived] = useState(false);
  const [itemId, setIteamId] = useState<number | string>("");
  const [filter, setFilter] = useState<string>("all");
  const [selectedTreatmentIds, setSelectedTreatmentIds] = useState<number[]>(
    []
  );
  const [selectedTreatmentIdsNew, setSelectedTreatmentIdsNew] = useState<
    number[]
  >([]);

  const treatment_Categories = useQuery(["categories"], async () => {
    const { data } = await axios.post(`/treatment_category`);
    return data;
  });

  const { data: playlistCategories } = useQuery(
    ["playlistCategories"],
    async () => {
      const { data } = await axios.post(`/treatment_category`);
      return data;
    }
  );

  const [treatmentPlans, setTreatmentPlans] = useState<any[]>([]);

  useEffect(() => {
    const fetchTreatmentPlans = async () => {
      try {
        const { data } = await axios.get(`/treatment`);
        const plans = data.treatments.map((plan: any) => ({
          ...plan,
          label: plan.description,
          value: plan.id,
        }));
        setTreatmentPlans(plans);
      } catch (error) {
        console.error("Error fetching treatment plans:", error);
      }
    };
    fetchTreatmentPlans();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const treatmentResponse = await axios.get("/treatment_category");
        const treatmentOptions = treatmentResponse.data.map((plan: any) => ({
          label: plan.category_name,
          value: plan.id,
        }));
        setTreatments(treatmentOptions);

        const userResponse = await axios.get("/user");
        setUserId(userResponse.data[1].medicube_user_id);
        setPracticeId(userResponse.data[1].medicube_practice_id);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    handleData(undefined, "");
    fetchData();
  }, []);

  useEffect(() => {
    if (currentCategory?.treatment_ids) {
      setSelectedTreatmentIds(currentCategory.treatment_ids);
    }
  }, [currentCategory]);

  const handleData = (category?: number, search?: string) => {
    setLoading(true);
    axios
      .get(`/playlist/`, { params: { category, search } })
      .then((response) => {
        const {
          default_user_playlists = [],
          default_practice_playlists = [],
          global_playlists = [],
          non_default_playlists = [],
          treatment_categories = [],
        } = response.data;

        const allPlaylists = [
          ...default_user_playlists.map((item: any, index: number) => {
            if (index === 0) {
              setIteamId(item.id);
            }
            return {
              ...item,
              type: "default_user_playlists",
            };
          }),
          ...default_practice_playlists.map((item: any) => ({
            ...item,
            type: "default_practice_playlists",
          })),
          ...global_playlists.map((item: any) => ({
            ...item,
            type: "global_playlists",
          })),
          ...non_default_playlists.map((item: any) => ({
            ...item,
            type: "non_default_playlists",
          })),
        ];

        const formattedData = allPlaylists.map((item: any) => {
          const videos = item.playist_items || [];
          const firstVideoTitle =
            videos.length > 0
              ? videos[0].title || `Category ${item.id}`
              : `Category ${item.id}`;

          return {
            id: item.id,
            name: item.title || firstVideoTitle,
            type: item.type,
            level: item.level,
            treatment_category_id: item.treatment_category_id,
            treatment_ids: item.treatment_ids,
            is_default: item.is_default,
            videos: videos.map((video: any) => ({
              title: video.title,
              url: video.url,
              thumbnail: video.thumbnail,
              description: video.description,
              platform: video.platform,
              duration: video.duration,
            })),
          };
        });

        setCategories(formattedData);

        if (formattedData.length > 0) {
          setCurrentCategory(formattedData[0]);
          setSelectedCategoryId(formattedData[0].id);

          const selectedCategory = treatment_categories.find(
            (cat: any) => cat.id === formattedData[0].id
          );

          setSelectedCategoryName(
            selectedCategory ? selectedCategory.name : "Unknown Category"
          );

          if (formattedData[0].videos.length > 0) {
            setCurrentVideo(formattedData[0].videos[0]);
          } else {
            setCurrentVideo(null);
          }
        } else {
          setCurrentCategory(null);
          setCurrentVideo(null);
        }

        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching the playlist data:", error);
        setLoading(false);
      });
  };

  const updatePlaylist = async (values: any) => {
    try {
      const payload = {
        title: values.playlistName,
        treatment_category_id: values.category_id,
        treatment_ids: selectedTreatmentIds,
        level: values.options,
      };

      await axios.put(`/playlist/${currentCategory.id}`, payload);

      try {
        const getResponse = await axios.get(`/playlist/${currentCategory.id}`);
        setLevel(getResponse.data.level);
        setIteamId(getResponse.data.id);
        setIsArchived(getResponse.data.is_archived);
        setSelectedCategoryName(getResponse.data.treatment_category_name);
      } catch (error) {
        console.error("Error fetching playlist:", error);
      }

      handleData();

      const abc = await axios.get(`/playlist/${itemId}`);
      const firstVideoTitle =
        abc.data.playist_items && abc.data.playist_items.length > 0
          ? abc.data.playist_items[0].title || `Category ${abc.data.id}`
          : `Category ${abc.data.id}`;

      const transformedData = {
        id: abc.data.id,
        name: abc.data.title || firstVideoTitle,
        type: abc.data.type || "default",
        level: abc.data.level,
        treatment_category_id: abc.data.treatment_category_id,
        treatment_ids: abc.data.treatment_ids || [],
        is_default: abc.data.is_default,
        videos: (abc.data.playist_items || []).map((video: any) => ({
          title: video.title,
          url: video.url,
          thumbnail: video.thumbnail,
          description: video.description,
          platform: video.platform,
          duration: video.duration,
        })),
      };

      onCategorySelect(transformedData);
      setSelectedCategoryId(transformedData.id);
      setCurrentCategory(transformedData);

      toast.success("Playlist edited successfully");
    } catch (error: any) {
      if (error.response && error.response.status === 400) {
        toast.error(
          `Error: ${
            error.response.data.message ||
            "Playlist template name is not unique."
          }`
        );
      } else {
        console.error("Error updating playlist:", error);
      }
    }
  };

  const clonePlaylist = async (values: any) => {
    try {
      if (!values.treatment_ids || values.treatment_ids.length === 0) {
        toast.error("Please select at least one treatment.");
        return;
      }

      if (!values.options || values.options.trim() === "") {
        toast.error("Please select a level.");
        return;
      }

      const payload = {
        title: values.playlistName,
        treatment_category_id: values.category_id,
        treatment_ids: values.treatment_ids
          ? values.treatment_ids.map((t: any) => t.value)
          : [],
        level: values.options,
      };

      const response = await axios.put(
        `/playlist/${currentCategory.id}/copy_global_playlist_to_private`,
        payload
      );
      setLevel(response.data.level);

      const newPlaylist = {
        id: response.data.id,
        name: values.playlistName,
        videos: response.data.playist_items.map((video: any) => ({
          id: video.id,
          title: video.title,
          url: video.url,
          thumbnail: video.thumbnail || "",
          description: video.description,
          type: video.type,
          platform: video.platform,
          duration: video.duration,
        })),
        level: response.data.level,
        type:
          response.data.level === "practice"
            ? "default_practice_playlists"
            : "default_user_playlists",
        is_default: response.data.is_default,
        treatment_category_id: response.data.treatment_category_id,
        treatment_ids: response.data.treatment_ids || [],
      };

      setIteamId(newPlaylist.id);
      setCategories((prevCategories) => [newPlaylist, ...prevCategories]);
      setCurrentCategory(newPlaylist);
      setSelectedCategoryId(newPlaylist.id);
      setCurrentVideo(
        newPlaylist.videos.length > 0
          ? {
              ...newPlaylist.videos[0],
              url: newPlaylist.videos[0].url,
            }
          : null
      );

      toast.success("Playlist created successfully");
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.detail ||
        "An error occurred while cloning the playlist.";
      toast.error(errorMessage);
      console.error("Error cloning playlist:", error);
    }
  };

  const handleSubmitPlaylistUpdate = (values: any) => {
    if (currentCategory.level === "global") {
      clonePlaylist(values);
    } else {
      updatePlaylist(values);
    }
  };

  const onCategorySelect = async (category: any) => {
    setSelectedCategoryId(category.id);
    try {
      const response = await axios.get(`/playlist/${category.id}`);
      setLevel(response.data.level);
      setIteamId(response.data.id);

      if (response.data.is_archived) {
        setIsArchived(true);
      } else {
        setIsArchived(false);
      }

      setSelectedCategoryName(response.data.treatment_category_name);
      setCurrentCategory(category);

      if (category.videos.length > 0) {
        setCurrentVideo(category.videos[0]);
      } else {
        setCurrentVideo(null);
      }

      logUserAction("Treatment Selected", "User clicked on a treatment", {
        treatment: category.name,
      });
    } catch (error) {
      console.error("Error fetching playlist:", error);
    }
  };

  const handleSubmitPlaylistSave = async (formValues: any) => {
    try {
      const { playlistName, category_id } = formValues;
      const categoryIdInt = parseInt(category_id, 10);

      const response = await axios.post("/playlist/", {
        title: playlistName,
        treatment_category_id: categoryIdInt,
        treatment_ids: selectedTreatmentIdsNew,
      });

      const newPlaylist = {
        id: response.data,
        name: playlistName,
        treatment_category_id: categoryIdInt,
        videos: [],
        level: "user",
        type: "default_user_playlists",
      };

      const getResponse = await axios.get(`/playlist/${newPlaylist.id}`);

      setIteamId(getResponse.data.id);
      setCategories((prevCategories) => [newPlaylist, ...prevCategories]);
      setCurrentCategory(newPlaylist);
      setSelectedCategoryId(newPlaylist.id);
      setSelectedCategoryName(getResponse.data.treatment_category_name);
      setSelectedTreatmentIds(getResponse.data.treatment_ids);
      setCurrentVideo(null);

      toast.success("Playlist created successfully");
      handleModalClose();
    } catch (error: any) {
      const errorMessage =
        error?.response?.data?.detail || "Error saving playlist.";
      toast.error(errorMessage);
      console.error("Error saving playlist:", error);
    }
  };

  const fetchPlaylistsByTreatment = (treatmentId: string) => {
    setLoading(true);
    axios
      .get(`/playlist/?category=${treatmentId}`)
      .then((response) => {
        const rawData = response.data;

        const normalizedItems = Array.isArray(rawData)
          ? rawData
          : [
              ...(rawData.default_user_playlists || []).map((item: any) => ({
                ...item,
                type: "default_user_playlists",
              })),
              ...(rawData.default_practice_playlists || []).map((item: any) => ({
                ...item,
                type: "default_practice_playlists",
              })),
              ...(rawData.global_playlists || []).map((item: any) => ({
                ...item,
                type: "global_playlists",
              })),
              ...(rawData.non_default_playlists || []).map((item: any) => ({
                ...item,
                type: "non_default_playlists",
              })),
            ];

        const data = normalizedItems.map((item: any) => {
          const videos = item.playist_items || [];
          const firstVideoTitle =
            videos.length > 0
              ? videos[0].title || `Category ${item.id}`
              : `Category ${item.id}`;

          return {
            id: item.id,
            name: item.title || firstVideoTitle,
            type: item.type,
            level: item.level,
            treatment_category_id: item.treatment_category_id,
            treatment_ids: item.treatment_ids,
            is_default: item.is_default,
            videos: videos.map((video: any) => ({
              title: video.title,
              url: video.url,
              thumbnail: video.thumbnail,
              description: video.description,
              platform: video.platform,
              duration: video.duration,
            })),
          };
        });

        setCategories(data);

        if (data.length > 0) {
          setCurrentCategory(data[0]);
          setSelectedCategoryId(data[0].id);
          if (data[0].videos.length > 0) {
            setCurrentVideo(data[0].videos[0]);
          } else {
            setCurrentVideo(null);
          }
        } else {
          setCurrentCategory(null);
          setCurrentVideo(null);
        }

        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching the playlist data:", error);
        setLoading(false);
      });
  };

  const handleSearch = useCallback(
    debounce(() => {
      if (searchParam.trim() === "") {
        handleData();
        return;
      }

      setSearchLoading(true);
      axios
        .get(`/playlist/?search=${searchParam}`)
        .then((response) => {
          const {
            default_user_playlists = [],
            default_practice_playlists = [],
            global_playlists = [],
            non_default_playlists = [],
            treatment_categories = [],
          } = response.data;

          const allPlaylists = [
            ...default_user_playlists.map((item: any, index: number) => {
              if (index === 0) {
                setIteamId(item.id);
              }
              return {
                ...item,
                type: "default_user_playlists",
              };
            }),
            ...default_practice_playlists.map((item: any) => ({
              ...item,
              type: "default_practice_playlists",
            })),
            ...global_playlists.map((item: any) => ({
              ...item,
              type: "global_playlists",
            })),
            ...non_default_playlists.map((item: any) => ({
              ...item,
              type: "non_default_playlists",
            })),
          ];

          const formattedData = allPlaylists.map((item: any) => {
            const videos = item.playist_items || [];
            const firstVideoTitle =
              videos.length > 0
                ? videos[0].title || `Category ${item.id}`
                : `Category ${item.id}`;

            return {
              id: item.id,
              name: item.title || firstVideoTitle,
              type: item.type,
              level: item.level,
              treatment_category_id: item.treatment_category_id,
              treatment_ids: item.treatment_ids,
              is_default: item.is_default,
              videos: videos.map((video: any) => ({
                title: video.title,
                url: video.url,
                thumbnail: video.thumbnail,
                description: video.description,
                platform: video.platform,
                duration: video.duration,
              })),
            };
          });

          setCategories(formattedData);

          if (formattedData.length > 0) {
            setCurrentCategory(formattedData[0]);
            setSelectedCategoryId(formattedData[0].id);

            const selectedCategory = treatment_categories.find(
              (cat: any) => cat.id === formattedData[0].id
            );

            setSelectedCategoryName(
              selectedCategory ? selectedCategory.name : "Unknown Category"
            );

            if (formattedData[0].videos.length > 0) {
              setCurrentVideo(formattedData[0].videos[0]);
            } else {
              setCurrentVideo(null);
            }
          } else {
            setCurrentCategory(null);
            setCurrentVideo(null);
          }

          setSearchLoading(false);
        })
        .catch((error) => {
          console.error("Error fetching the playlist data:", error);
          setSearchLoading(false);
        });
    }, 300),
    [searchParam]
  );

  useEffect(() => {
    if (searchParam.trim() !== "") {
      handleSearch();
    }
  }, [searchParam, handleSearch]);

  useEffect(() => {
    if (selectedTreatment) {
      fetchPlaylistsByTreatment(selectedTreatment);
    } else if (!searchParam.trim()) {
      handleData();
    }
  }, [selectedTreatment]);

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    setSearchParam(value);
  };

  const handleTreatmentFilterChange = (
    event: React.ChangeEvent<{ value: unknown }>
  ) => {
    setSelectedTreatment(event.target.value as string);
  };

  const onVideoSelect = (video: any) => {
    logCurrentVideoTime();
    setCurrentVideo(video);

    logUserAction("Video Selected", "User clicked on a Video", {
      video: video.title,
    });
    resetTimeTracking();
  };

  const logCurrentVideoTime = () => {
    if (startTimeRef.current && currentVideo) {
      const endTime = Date.now();
      const duration = (endTime - startTimeRef.current) / 1000;
      const actualPlaybackTime = playbackTimeRef.current;

      logUserAction("Video Watched", "User stopped watching a video", {
        video: currentVideo.title,
        duration,
        actualPlaybackTime,
      });
    }
  };

  const logUserAction = (event: string, description: string, data: any) => {
    if (!userid) {
      console.warn("User ID is not defined. Log action is not sent.");
      return;
    }

    axios
      .post(`/log`, {
        type: "info",
        description,
        event,
        data,
        practice_id: practiceId,
        user_id: userid,
      })
      .then(() => {})
      .catch((error) => {
        console.error("Error logging user action:", error);
      });
  };

  const resetTimeTracking = () => {
    startTimeRef.current = Date.now();
    playbackTimeRef.current = 0;
  };

  const handleVideoStart = () => {
    resetTimeTracking();
  };

  const handleVideoProgress = (state: any) => {
    setLastPlayedSeconds(state.playedSeconds);
    playbackTimeRef.current = state.playedSeconds;
  };

  const handleVideoPause = () => {
    setPlayedBeforePause(lastPlayedSeconds);
    handleVideoResume();
    logCurrentVideoTime();
    resetTimeTracking();
  };

  const handleVideoResume = () => {
    const newPlayedSeconds = lastPlayedSeconds || 0;
    const calculatedSeekTime = newPlayedSeconds - (playedBeforePause || 0);
    setSeekTime(calculatedSeekTime);
    setSeekTime(null);
  };

  const handleVideoEnd = () => {
    logCurrentVideoTime();
    resetTimeTracking();
  };

  const handleModalOpen = () => setOpenModalPlaylist(true);
  const handleModalClose = () => setOpenModalPlaylist(false);
  const handleModalOpenPlaylist = () => setOpenModal(true);

  const handleTreatmentChange = (event: any, newValue: any[]) => {
    setSelectedTreatmentIds(newValue.map((option) => option.value));
  };

  const handleTreatmentChangeNew = (event: any, newValue: any[]) => {
    setSelectedTreatmentIdsNew(newValue.map((option) => option.value));
  };

  const handleSubmitPlaylistItemSave = async (newVideo: any) => {
    try {
      const updatedCategory = { ...currentCategory };
      updatedCategory.videos.push(newVideo);

      setCategories((prevCategories) =>
        prevCategories.map((cat) =>
          cat.id === updatedCategory.id ? updatedCategory : cat
        )
      );

      setCurrentCategory(updatedCategory);
      setCurrentVideo(newVideo);
      setOpenModal(false);
    } catch (error) {
      toast.error("Error saving playlist item.");
      console.error("Error saving playlist item:", error);
    }
  };

  const getFilteredPlaylists = () => {
    if (filter === "all") return categories;

    let filtered: any[] = [];

    if (filter === "default_user_playlists") {
      filtered = categories.filter(
        (cat) => cat.type === "default_user_playlists"
      );
    } else if (filter === "global_playlists") {
      filtered = categories.filter((cat) => cat.type === "global_playlists");
    } else if (filter === "non_default_playlists") {
      filtered = categories.filter(
        (cat) => cat.type === "non_default_playlists"
      );
    } else if (filter === "treatment_categories") {
      filtered = categories.filter(
        (cat) => cat.type === "treatment_categories"
      );
    } else if (filter === "default_practice_playlists") {
      filtered = categories.filter(
        (cat) => cat.type === "default_practice_playlists"
      );
    }

    return filtered.length > 0 ? filtered : null;
  };

  const filteredPlaylists = getFilteredPlaylists();

  const availableTreatmentFilters = React.useMemo(() => {
    const usedCategoryIds = new Set(
      categories
        .map((item) => item.treatment_category_id)
        .filter((id) => id !== null && id !== undefined)
    );

    return treatments.filter((treatment) => usedCategoryIds.has(treatment.value));
  }, [categories, treatments]);

  const handleDeletePlaylist = (playlistId: number | string) => {
    axios
      .delete(`/playlist/${playlistId}`)
      .then(() => {
        setCategories((prevCategories) =>
          prevCategories.filter((category) => category.id !== playlistId)
        );

        if (currentCategory?.id === playlistId) {
          setCurrentCategory(null);
          setCurrentVideo(null);
        }

        handleData();
        toast.success("Playlist deleted successfully");
      })
      .catch((error) => {
        toast.error("Error deleting playlist.");
        console.error("Error deleting playlist:", error);
      });
  };

  const handleDelete = async (videoToDelete: any) => {
    try {
      const updatedVideos = currentCategory.videos.filter(
        (video: any) => video !== videoToDelete
      );

      const payload = updatedVideos.map(({ id, thumbnail, ...video }: any) => ({
        title: video.title || "",
        description: video.description || "",
        url: video.url,
        platform: video.platform || "s3",
        duration: video.duration || "00:00:00",
        type: "mp4",
      }));

      const response = await axios.put(
        `playlist/${itemId}/save_playlist_items`,
        payload
      );

      if (response.status === 200) {
        const result = await response.data;
        if (result === true) {
          toast.success("Playlist item deleted successfully");

          const updatedCategory = {
            ...currentCategory,
            videos: updatedVideos,
          };

          setCategories((prevCategories) =>
            prevCategories.map((category) =>
              category.id === updatedCategory.id ? updatedCategory : category
            )
          );

          setCurrentCategory(updatedCategory);
        } else {
          toast.error("Failed to delete playlist item.");
        }
      } else {
        toast.error("Failed to delete playlist item.");
      }
    } catch (error) {
      console.error("Error deleting playlist item:", error);
      toast.error("An error occurred while deleting the playlist item.");
    }
  };

  const extractTikTokId = (url?: string | null) => {
    if (!url) return null;
    const match = url.match(/video\/(\d+)/);
    return match ? match[1] : null;
  };

  if (loading) {
    return (
      <div className={styles.videoLoadingContainer}>
        <div className={styles.videoLoadingCard}>
          <Lottie
            animationData={videoLoadingAnimation}
            style={{ width: 260, height: 260 }}
          />
          <img
            src="/logo.png"
            alt="Overlay image"
            className={styles.loadingLogo}
          />
          <p className={styles.loadingText}>Loading your video library…</p>
        </div>
      </div>
    );
  }

  return (
    <>
      <Header />
      <Box className={styles.app}>
        <div className={styles.pageHeaderRow}>
          <div>
            <p className={styles.pageEyebrow}>Patient education</p>
            <h1 className={styles.pageTitle}>Video Gallery</h1>
            {selectedCategoryName && currentCategory && (
              <p className={styles.pageSubtitle}>
                {selectedCategoryName} ·{" "}
                <span className={styles.pageSubtitlePill}>
                  {currentCategory.level === "global"
                    ? "Global"
                    : currentCategory.level === "practice"
                    ? "Practice"
                    : "User"}
                  {isArchived && " · Archived"}
                </span>
              </p>
            )}
          </div>

          {currentCategory && (
            <div className={styles.currentStatsPill}>
              <span className={styles.currentStatsLabel}>Videos</span>
              <span className={styles.currentStatsValue}>
                {currentCategory?.videos?.length || 0}
              </span>
            </div>
          )}
        </div>

        <Dialog
          open={openModalPlaylist}
          onClose={handleModalClose}
          PaperProps={{
            sx: {
              width: "600px",
              borderRadius: "18px",
              padding: "16px 20px",
            },
          }}
        >
          <DialogTitle className={styles.dialogTitle}>
            Create new playlist
          </DialogTitle>
          <DialogContent>
            <Form
              onSubmit={handleSubmitPlaylistSave}
              render={({ handleSubmit }) => (
                <form onSubmit={handleSubmit} className={styles.dialogForm}>
                  <Box mt={1.5}>
                    <Field name="playlistName">
                      {({ input }) => (
                        <TextField
                          label="Playlist name"
                          variant="outlined"
                          fullWidth
                          {...input}
                          autoFocus
                          size="small"
                        />
                      )}
                    </Field>
                  </Box>

                  <Box>
                    <Field name="category_id">
                      {({ input }) => (
                        <TextField
                          select
                          label="Category"
                          variant="outlined"
                          fullWidth
                          {...input}
                          margin="normal"
                          size="small"
                        >
                          {playlistCategories?.map((category: any) => (
                            <MenuItem value={category.id} key={category.id}>
                              {category.category_name}
                            </MenuItem>
                          ))}
                        </TextField>
                      )}
                    </Field>
                  </Box>

                  <Box mb={1.5} mt={1}>
                    <Autocomplete
                      name="treatment_idsnew"
                      label="Treatment(s)"
                      multiple
                      required={true}
                      options={treatmentPlans}
                      getOptionLabel={(option: any) => option.label}
                      getOptionSelected={(option: any, value: any) =>
                        option.value === value
                      }
                      onChange={handleTreatmentChangeNew}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Link to treatments"
                          size="small"
                        />
                      )}
                    />
                  </Box>

                  <DialogActions className={styles.dialogActions}>
                    <Button
                      onClick={handleModalClose}
                      variant="outlined"
                      size="small"
                    >
                      Cancel
                    </Button>
                    <Button type="submit" variant="contained" size="small">
                      Create playlist
                    </Button>
                  </DialogActions>
                </form>
              )}
            />
          </DialogContent>
        </Dialog>

        <Grid container spacing={2} className={styles.layoutGrid}>
          <Grid item xs={12} md={3}>
            <Box className={`${styles.glassCard} ${styles.categoriesBox}`}>
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                mb={1.5}
              >
                <div>
                  <h2 className={styles.sectionTitle}>Playlists</h2>
                  <p className={styles.sectionSubtitle}>
                    Browse, filter & manage your video collections.
                  </p>
                </div>
                <Button
                  variant="contained"
                  onClick={handleModalOpen}
                  size="small"
                  className={styles.addPlaylistButton}
                >
                  + New
                </Button>
              </Box>

              <Box className={styles.searchFilterBox}>
                <TextField
                  label="Search playlists"
                  variant="filled"
                  value={searchParam}
                  name="searchParam"
                  onChange={handleInputChange}
                  fullWidth
                  size="small"
                  InputProps={{
                    className: styles.searchInput,
                  }}
                />

                <Select
                  value={selectedTreatment}
                  onChange={handleTreatmentFilterChange}
                  displayEmpty
                  variant="filled"
                  fullWidth
                  size="small"
                  className={styles.selectBox}
                >
                  <MenuItem value="" disabled>
                    Filter by treatment category
                  </MenuItem>

                  {availableTreatmentFilters.map((treatment) => (
                    <MenuItem key={treatment.value} value={treatment.value}>
                      {treatment.label}
                    </MenuItem>
                  ))}
                </Select>
              </Box>

              <Box mt={1.5} display="flex" flexWrap="wrap" gap={0.5}>
                <Chip
                  label="All"
                  onClick={() => setFilter("all")}
                  color={filter === "all" ? "primary" : "default"}
                  size="small"
                  className={styles.filterChip}
                />
                <Chip
                  label="User"
                  onClick={() => setFilter("default_user_playlists")}
                  color={
                    filter === "default_user_playlists" ? "primary" : "default"
                  }
                  size="small"
                  className={styles.filterChip}
                />
                <Chip
                  label="Practice"
                  onClick={() => setFilter("default_practice_playlists")}
                  color={
                    filter === "default_practice_playlists"
                      ? "primary"
                      : "default"
                  }
                  size="small"
                  className={styles.filterChip}
                />
                <Chip
                  label="Global"
                  onClick={() => setFilter("global_playlists")}
                  color={filter === "global_playlists" ? "primary" : "default"}
                  size="small"
                  className={styles.filterChip}
                />
                <Chip
                  label="Archived"
                  onClick={() => setFilter("non_default_playlists")}
                  color={
                    filter === "non_default_playlists" ? "primary" : "default"
                  }
                  size="small"
                  className={styles.filterChip}
                />
              </Box>

              {(searchParam || selectedTreatment) && (
                <Button
                  type="button"
                  title="Clear Filters"
                  onClick={() => {
                    setSearchParam("");
                    setSelectedTreatment("");
                    setFilter("all");
                    handleData();
                  }}
                  className={styles.clearFiltersButton}
                  startIcon={<ClearIcon fontSize="small" />}
                >
                  Clear filters
                </Button>
              )}

              {searchLoading && (
                <Box mt={1} display="flex" justifyContent="center">
                  <CircularProgress size={20} />
                </Box>
              )}

              <Box
                mt={1}
                className={styles.playlistListContainer}
                sx={{ maxHeight: "650px", overflowY: "auto" }}
              >
                {filteredPlaylists === null ? (
                  <p className={styles.emptyStateText}>No playlists found</p>
                ) : (
                  filteredPlaylists.map((category: any, index: number) => (
                    <div
                      key={index}
                      className={`${styles.categoryItem} ${
                        category.id === selectedCategoryId
                          ? styles.categoryItemActive
                          : ""
                      }`}
                      onClick={() => onCategorySelect(category)}
                    >
                      <div className={styles.categoryContainer}>
                        {category.type === "global_playlists" && (
                          <img
                            src="/logo_mono.png"
                            alt="global"
                            className={styles.smallImage}
                          />
                        )}
                        {category.type === "default_user_playlists" && (
                          <Person2Icon className={styles.categoryIcon} />
                        )}
                        {category.type === "default_practice_playlists" && (
                          <Groups2Icon className={styles.categoryIcon} />
                        )}
                        {category.type === "non_default_playlists" && (
                          <DeleteForeverIcon
                            sx={{ color: "red" }}
                            className={styles.categoryIcon}
                          />
                        )}

                        <div className={styles.categoryMeta}>
                          <span className={styles.categoryName}>
                            {category.name}
                          </span>
                          <span className={styles.categoryMetaLine}>
                            {category.level === "global"
                              ? "Global"
                              : category.level === "practice"
                              ? "Practice"
                              : "User"}{" "}
                            · {category?.videos?.length || 0} videos
                          </span>
                        </div>
                      </div>

                      {category.type !== "global_playlists" &&
                        category.type !== "non_default_playlists" && (
                          <IconButton
                            aria-label="delete"
                            size="small"
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              confirmAlert({
                                title: "Delete playlist?",
                                message:
                                  "This will remove the playlist and its configuration for this account.",
                                buttons: [
                                  {
                                    label: "Delete",
                                    onClick: async () =>
                                      handleDeletePlaylist(category.id),
                                  },
                                  { label: "Cancel", onClick: () => {} },
                                ],
                              });
                            }}
                            className={styles.deleteIcon}
                          >
                            <Delete fontSize="small" />
                          </IconButton>
                        )}
                    </div>
                  ))
                )}
              </Box>
            </Box>
          </Grid>

          <Grid item xs={12} md={9}>
            <Box className={`${styles.glassCard} ${styles.box}`}>
              <div className={styles.rightHeaderRow}>
                <div>
                  <h2 className={styles.playlistTitle}>
                    {currentCategory?.name || "No playlist selected"}
                  </h2>
                  <p className={styles.playlistMeta}>
                    {currentCategory
                      ? `${currentCategory?.videos?.length || 0} video${
                          (currentCategory?.videos?.length || 0) === 1 ? "" : "s"
                        } linked`
                      : "Select a playlist from the left"}
                  </p>
                </div>

                {currentCategory && (
                  <div className={styles.playlistLevelBadge}>
                    {currentCategory.level === "global" && (
                      <>
                        <PublicIcon fontSize="small" />
                        <span>Global template</span>
                      </>
                    )}
                    {currentCategory.level === "practice" && (
                      <>
                        <BusinessIcon fontSize="small" />
                        <span>Practice default</span>
                      </>
                    )}
                    {currentCategory.level === "user" && (
                      <>
                        <Person2Icon fontSize="small" />
                        <span>User playlist</span>
                      </>
                    )}
                    {isArchived && (
                      <>
                        <ArchiveIcon fontSize="small" />
                        <span>Archived</span>
                      </>
                    )}
                  </div>
                )}
              </div>

              <div className={styles.playerContainer}>
                <div className={styles.playerWrapper}>
                  {currentVideo || categories.length === 0 ? (
                    currentVideo?.platform === "tiktok" ? (
                      <iframe
                        id="tiktok-player"
                        src={`https://www.tiktok.com/player/v1/${extractTikTokId(
                          currentVideo.url
                        )}?music_info=1&description=1`}
                        width="100%"
                        height="520"
                        allow="autoplay; fullscreen"
                        title="TikTok Player"
                        style={{
                          border: "none",
                          marginTop: 10,
                          borderRadius: 16,
                        }}
                      />
                    ) : currentVideo ? (
                      <ReactPlayerMain
                        url={currentVideo?.url}
                        controls
                        width="100%"
                        height="520px"
                        onStart={handleVideoStart}
                        onProgress={handleVideoProgress}
                        onPause={handleVideoPause}
                        onEnded={handleVideoEnd}
                        onPlay={handleVideoResume}
                        className={styles.reactPlayer}
                      />
                    ) : (
                      <div className={styles.noVideoState}>
                        <p>No videos in this playlist yet.</p>
                        {level !== "global" && !isArchived && (
                          <Button
                            variant="contained"
                            onClick={handleModalOpenPlaylist}
                            size="small"
                          >
                            Add first video
                          </Button>
                        )}
                      </div>
                    )
                  ) : (
                    <div className={styles.noVideoState}>No videos available</div>
                  )}
                </div>

                <div className={styles.playlist}>
                  <div className={styles.playlistHeaderRow}>
                    <h3>Videos</h3>
                    {level !== "global" && !isArchived && (
                      <Button
                        variant="contained"
                        size="small"
                        onClick={handleModalOpenPlaylist}
                      >
                        Add video
                      </Button>
                    )}
                  </div>

                  {categories.length === 0 ? (
                    <Skeleton
                      variant="rectangular"
                      height={120}
                      className={styles.playlistSkeleton}
                    />
                  ) : currentCategory?.videos?.length ? (
                    <div className={styles.playlistItemsScroller}>
                      {currentCategory?.videos.map(
                        (video: any, index: number) => (
                          <div
                            key={index}
                            className={`${styles.playlistItem} ${
                              video === currentVideo ? styles.active : ""
                            }`}
                            onClick={() => onVideoSelect(video)}
                          >
                            <img
                              src={video.thumbnail}
                              alt={video.title}
                              className={styles.thumbnail}
                            />

                            <div className={styles.playlistTextBlock}>
                              <div className={styles.playlistVideoTitle}>
                                {video.title}
                              </div>
                              {video.platform && (
                                <div className={styles.playlistVideoMeta}>
                                  {video.platform.toUpperCase()} ·{" "}
                                  {video.duration || "00:00"}
                                </div>
                              )}
                            </div>

                            <DeleteIcon
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                confirmAlert({
                                  title: "Delete video?",
                                  message:
                                    "This will remove the video from this playlist.",
                                  buttons: [
                                    {
                                      label: "Delete",
                                      onClick: async () => {
                                        await handleDelete(video);
                                      },
                                    },
                                    { label: "Cancel", onClick: () => {} },
                                  ],
                                });
                              }}
                              className={styles.playlistDeleteIcon}
                            />
                          </div>
                        )
                      )}
                    </div>
                  ) : (
                    <div className={styles.emptyStateSmall}>
                      No videos in this playlist yet.
                    </div>
                  )}

                  {currentCategory?.videos[0]?.platform === "s3" && <p></p>}

                  <PlaylistModal
                    open={openModal}
                    onClose={() => setOpenModal(false)}
                    onSubmit={handleSubmitPlaylistItemSave}
                    playlistId={selectedCategoryId}
                    currentCategory={currentCategory}
                  />
                </div>
              </div>

              {(currentVideo || categories.length === 0) && currentCategory && (
                <Box mb={1} mt={3} className={styles.metaFormWrapper}>
                  <div className={styles.metaHeaderRow}>
                    <div>
                      <h3 className={styles.metaTitle}>Playlist details</h3>
                      <p className={styles.metaSubtitle}>
                        Rename, re-scope and attach treatments.
                      </p>
                    </div>
                  </div>

                  <Form
                    key={currentCategory?.id}
                    onSubmit={handleSubmitPlaylistUpdate}
                    render={({ handleSubmit }) => (
                      <form
                        onSubmit={handleSubmit}
                        className={styles.metaFormInner}
                      >
                        <Box mt={1}>
                          <Field
                            name="playlistName"
                            initialValue={currentCategory?.name || ""}
                          >
                            {({ input }) => (
                              <TextField
                                label="Playlist name"
                                variant="outlined"
                                fullWidth
                                {...input}
                                size="small"
                              />
                            )}
                          </Field>
                        </Box>

                        <Box mt={1.5}>
                          <Field
                            name="category_id"
                            initialValue={
                              currentCategory?.treatment_category_id || ""
                            }
                          >
                            {({ input }) => (
                              <TextField
                                select
                                label="Category"
                                variant="outlined"
                                fullWidth
                                {...input}
                                margin="normal"
                                size="small"
                              >
                                {playlistCategories?.map((category: any) => (
                                  <MenuItem
                                    value={category.id}
                                    key={category.id}
                                  >
                                    {category.category_name}
                                  </MenuItem>
                                ))}
                              </TextField>
                            )}
                          </Field>
                        </Box>

                        <Box mb={1.5} mt={0.5}>
                          <Autocomplete
                            name="treatment_ids"
                            label="Treatment"
                            multiple
                            required
                            options={treatmentPlans}
                            getOptionLabel={(option: any) => option.label}
                            isOptionEqualToValue={(option: any, value: any) =>
                              option.value === value.value ||
                              option.value === value
                            }
                            value={treatmentPlans.filter((option: any) =>
                              selectedTreatmentIds.includes(option.value)
                            )}
                            onChange={handleTreatmentChange}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Linked treatments"
                                size="small"
                                error={selectedTreatmentIds.length === 0}
                                helperText={
                                  selectedTreatmentIds.length === 0
                                    ? "Select at least one treatment"
                                    : ""
                                }
                              />
                            )}
                          />
                        </Box>

                        <Box
                          display="flex"
                          alignItems="center"
                          gap={2}
                          mb={1.5}
                          mt={0.5}
                          className={styles.levelRow}
                        >
                          <FormControl component="fieldset">
                            <FormLabel component="legend">
                              Visibility level
                            </FormLabel>
                            {currentCategory?.level && (
                              <Field
                                name="options"
                                initialValue={currentCategory.level}
                              >
                                {({ input }) => (
                                  <RadioGroup
                                    row
                                    {...input}
                                    value={input.value}
                                    onChange={input.onChange}
                                  >
                                    <FormControlLabel
                                      value="user"
                                      control={<Radio size="small" />}
                                      label="User only"
                                    />
                                    <FormControlLabel
                                      value="practice"
                                      control={<Radio size="small" />}
                                      label="Practice"
                                    />
                                  </RadioGroup>
                                )}
                              </Field>
                            )}
                          </FormControl>
                        </Box>

                        <Button
                          type="submit"
                          variant="contained"
                          className={styles.saveButton}
                        >
                          Save changes
                        </Button>
                      </form>
                    )}
                  />
                </Box>
              )}
            </Box>
          </Grid>
        </Grid>
      </Box>
    </>
  );
}